import React from 'react';
import { Button } from '../ui/button';
import { Sparkles, ChevronDown, ChevronUp, Check, XCircle, Loader2 } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const PendingSuggestionCard = ({
  pendingSuggestion,
  previewExpanded,
  setPreviewExpanded,
  applyingChanges,
  onApply,
  onDismiss,
}) => {
  if (!pendingSuggestion) return null;

  return (
    <div className="border-t border-amber-200 bg-amber-50 p-4">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <Sparkles className="h-4 w-4 text-amber-600" />
          <span className="text-xs font-semibold text-amber-700">Suggested Changes</span>
        </div>
        <button
          onClick={() => setPreviewExpanded(!previewExpanded)}
          className="text-xs text-amber-600 hover:text-amber-700 flex items-center gap-1"
        >
          {previewExpanded ? 'Collapse' : 'Preview'}
          {previewExpanded ? <ChevronDown className="h-3 w-3" /> : <ChevronUp className="h-3 w-3" />}
        </button>
      </div>

      {previewExpanded && (
        <div className="mb-3 max-h-48 overflow-auto bg-white rounded-lg border border-amber-200 p-3 text-xs">
          <div className="prose prose-xs prose-slate max-w-none">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {pendingSuggestion.content.slice(0, 3000) + (pendingSuggestion.content.length > 3000 ? '\n\n... (content truncated in preview)' : '')}
            </ReactMarkdown>
          </div>
        </div>
      )}

      <div className="flex gap-2">
        <Button
          onClick={onApply}
          disabled={applyingChanges}
          className="flex-1 bg-green-600 hover:bg-green-700 text-white text-xs h-8"
          size="sm"
        >
          {applyingChanges ? (
            <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" />
          ) : (
            <Check className="h-3.5 w-3.5 mr-1" />
          )}
          {applyingChanges ? 'Applying...' : 'Apply Changes'}
        </Button>
        <Button
          onClick={onDismiss}
          variant="outline"
          className="text-xs h-8 border-amber-300 text-amber-700 hover:bg-amber-100"
          size="sm"
        >
          <XCircle className="h-3.5 w-3.5 mr-1" />
          Dismiss
        </Button>
      </div>
    </div>
  );
};

export default PendingSuggestionCard;
